module.exports = __webpack_public_path__ + "static/media/jenkins.b2527f01.svg";